import axios from "axios";
import { resetAuthData, updateToken } from "../app/providers/authSlice";
import { store } from "../app/store";
//import Swal from "sweetalert2";
//import style from "../styles/styles.css";

var app_url =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_PROD_API_URL
    : process.env.REACT_APP_DEV_API_URL;
export { app_url };

const http = axios.create({
  baseURL: app_url,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Fonction pour afficher le popup
function showPopup() {
  document.getElementById("custom-popup").style.display = "flex";
}

// Fonction pour masquer le popup
function hidePopup() {
  document.getElementById("custom-popup").style.display = "none";
}

// Compteur de requêtes actives (supporte les appels parallèles ex: React Query)
let activeRequests = 0;

// Les requêtes de fond (préchargement paginé, rafraîchissement silencieux)
// passent `skipGlobalLoader: true` dans leur config : elles ne déclenchent pas
// le loader plein écran, qui est réservé aux actions lancées par l'utilisateur.
const usesGlobalLoader = (config) => !config?.skipGlobalLoader;

function acquireLoader(config) {
  if (!usesGlobalLoader(config)) return;
  if (activeRequests === 0) {
    showPopup();
  }
  activeRequests++;
}

function releaseLoader(config) {
  if (!usesGlobalLoader(config)) return;
  // Math.max : sans lui, une requête libérée deux fois rendrait le compteur
  // négatif et la condition `=== 0` ne serait plus jamais vraie — le loader
  // resterait alors affiché indéfiniment.
  activeRequests = Math.max(0, activeRequests - 1);
  if (activeRequests === 0) {
    setTimeout(() => {
      hidePopup();
    }, 500);
  }
}

//créer un intercepteur
http.interceptors.request.use(
  (config) => {
    acquireLoader(config);

    const state = store.getState();
    const token = state.auth.token;

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

// Add a response interceptor
http.interceptors.response.use(
  (response) => {
    releaseLoader(response.config);
    return response;
  },
  async (error) => {
    //Récupérer la requette initiale
    const originalRequest = error.config;

    // La requête est terminée (en échec) : on la libère tout de suite, avant
    // la branche 401. Le rejeu éventuel repassera par l'intercepteur de requête
    // et incrémentera à nouveau.
    releaseLoader(originalRequest);

    // Masquer le loader
    //hidePopup();
    // Mettre à jour l'état du chargement
    //isLoading = false;

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axios(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const state = store.getState();
      const refreshToken = state.auth.refreshToken;

      // Afficher le loader pour l'actualisation du token
      showPopup();

      return new Promise((resolve, reject) => {
        axios
          .post(`${app_url}api/v01/web/auth/refresh-token`, { refreshToken })
          .then(({ data }) => {
            store.dispatch(updateToken(data));
            http.defaults.headers.common["Authorization"] =
              "Bearer " + data.token;
            originalRequest.headers["Authorization"] = "Bearer " + data.token;
            processQueue(null, data.token);
            resolve(http(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            store.dispatch(resetAuthData());
            window.location.href = "/";
            reject(err);
          })
          .finally(() => {
            // Masquer le loader après l'actualisation du token
            hidePopup();
            isRefreshing = false;
          });
      });
    }
    return Promise.reject(error);
  },
);

export default http;
